import React from 'react';
import PropTypes from 'prop-types';

function FiltroRecebiveis({ filtro, onFiltroChange }) {
  const handleFiltroChange = (e) => {
    const { value } = e.target;
    onFiltroChange('status', value); // Passa a chave do filtro e o novo valor
  };

  return (
    <div className="mb-6">
      <label
        htmlFor="filtro"
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        Filtrar por Status:
      </label>
      <select
        id="filtro"
        value={filtro.status}
        onChange={handleFiltroChange}
        className="block w-full md:w-1/3 p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      >
        <option value="Todos">Todos</option>
        <option value="Pendente">Pendente</option>
        <option value="Recebido">Recebido</option>
      </select>
    </div>
  );
}

// Definindo propTypes para validação de tipos
FiltroRecebiveis.propTypes = {
  filtro: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
  onFiltroChange: PropTypes.func.isRequired,
};

export default FiltroRecebiveis;
